var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"link-wrapper",on:{"click":_vm.scrollToTop}},[_vm._v(_vm._s(_vm.getStaticText[_vm.lang].toTopButton))])}
var staticRenderFns = []

export { render, staticRenderFns }